/* Perito Moreno by Zoon Network · waitlist and vote sign-ups go to Perito Moreno Admin (/apps/mb/wait).
   Product-page waitlist (inside [data-wait-box]): the app is the only place it is sent. Shopify's customer form is
   slow (it re-renders the whole page), adds tags only for new customers, and needs an email; the app saves email or
   WhatsApp number for anyone. The thank-you shows only once the app answers that the sign-up is saved; someone already
   on the list is told so (no second "No."), and if it can't be saved the form stays with a message to try again.
   Other forms (Monthly Bangers, votes) carry on with Shopify's form; a copy goes to the app (fire and forget).
   The "Your data" form (data-form="data") also carries on with Shopify's contact form (the store gets the email); a copy
   goes to the app's Privacy page (/apps/mb/privacy). Cookie banner choices go there too (/apps/mb/consent), as proof of
   consent: Shopify fires visitorConsentCollected for its own banner and for the theme's (pm.js setTrackingConsent). */
(() => {
  'use strict';
  if (window.PM_WAIT) return; window.PM_WAIT = true;
  const fix = v => { let d = String(v || '').replace(/\D/g, ''); if (!d) return ''; if (d.length === 11 && d[0] === '0') d = d.slice(1); if (d.length === 10) d = '91' + d; return '+' + d };
  /* Shopify's spam check calls form.submit() itself once its token is ready: a form the app is handling never goes */
  const nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () { if (this.dataset.pmApp) return; nativeSubmit.call(this) };
  const say = (f, msg) => { let s = f.nextElementSibling && f.nextElementSibling.classList.contains('ferr') ? f.nextElementSibling : null; if (!msg) { if (s) s.remove(); return } if (!s) { s = document.createElement('small'); s.className = 'ferr'; s.setAttribute('role', 'alert'); f.after(s) } s.textContent = msg };
  const join = async (f, body) => {
    if (f.dataset.pmApp) return;
    f.dataset.pmApp = '1'; f.setAttribute('aria-busy', 'true'); say(f, '');
    const btn = f.querySelector('button'), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding you…' }
    const ctl = new AbortController(), stop = setTimeout(() => ctl.abort(), 20000);
    try {
      const r = await fetch('/apps/mb/wait', { method: 'POST', body, credentials: 'same-origin', signal: ctl.signal });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || '');
      const tpl = f.querySelector('template[data-wait-done]');
      if (tpl) {
        f.replaceChildren(tpl.content.cloneNode(true));
        if (d.already) { const b = f.querySelector('b'); if (b) b.textContent = (tpl.dataset.again || 'You’re already on the list') + '.' }
      }
      const s = f.querySelector('[role="status"]'); if (s) { s.setAttribute('tabindex', '-1'); s.focus({ preventScroll: true }) }
      if (!d.already) f.dispatchEvent(new CustomEvent('pm:form-sent', { bubbles: true, detail: { id: f.id, ok: true } }));
    } catch (x) {
      say(f, x.message || 'We couldn’t add you just now. Please try again in a moment.');
      if (btn) { btn.disabled = false; btn.textContent = label }
      f.removeAttribute('aria-busy'); delete f.dataset.pmApp;
    } finally { clearTimeout(stop) }
  };
  const copy = (path, body) => { try { fetch(path, { method: 'POST', body, credentials: 'same-origin', keepalive: true }).catch(() => {}) } catch (x) { } };
  document.addEventListener('visitorConsentCollected', e => {
    const d = e.detail || {}, yes = v => v ? '1' : '0';
    let region = ''; try { const cp = window.Shopify && Shopify.customerPrivacy; region = (cp && cp.getRegion && cp.getRegion()) || '' } catch (x) { }
    copy('/apps/mb/consent', new URLSearchParams({ analytics: yes(d.analyticsAllowed), marketing: yes(d.marketingAllowed), preferences: yes(d.preferencesAllowed), sale_of_data: yes(d.saleOfDataAllowed), region, page: location.pathname }));
  });
  /* capture phase, after pm.js has checked the form (an invalid form is stopped before this runs) */
  document.addEventListener('submit', e => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement) || e.defaultPrevented) return;
    if (f.dataset.form === 'data') {
      const email = (f.querySelector('[name="contact[email]"]') || {}).value || '';
      const ask = ((f.querySelector('[name="contact[Request]"]:checked') || {}).value || '').toLowerCase();
      const kind = /delete|erase|remove/.test(ask) ? 'erase' : /correct|change|update/.test(ask) ? 'correct' : 'export';
      if (email.trim()) copy('/apps/mb/privacy', new URLSearchParams({ kind, email: email.trim(), confirm: '1', details: ask }));
      return;
    }
    const t = f.querySelector('input[name="contact[tags]"]');
    if (!t || !/(^|,)\s*(wait|vote)-/.test(t.value)) return;
    const v = n => { const i = f.querySelector(`[name="${n}"]`); return i ? i.value.trim() : '' };
    const w = f.querySelector('[data-wa]');
    const typed = v('contact[email]');
    const number = !!f.querySelector('[data-contact]') && typed !== '' && !typed.includes('@');
    const body = new URLSearchParams({
      tags: t.value,
      email: number ? '' : typed,
      name: [v('contact[first_name]'), v('contact[last_name]')].join(' ').trim(),
      phone: number ? fix(typed) : v('contact[phone]') || (w ? fix(w.value) : '')
    });
    if (f.closest('[data-wait-box]') && f.querySelector('template[data-wait-done]')) { e.preventDefault(); e.stopImmediatePropagation(); join(f, body); return }
    if (!body.get('email')) return;
    try { fetch('/apps/mb/wait', { method: 'POST', body, credentials: 'same-origin', keepalive: true }).catch(() => {}) } catch (x) { }
  }, true);
})();
